import * as React from 'react';
const SvgList = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      d="M19.95 16.27a.5.5 0 0 0-.22-.22.5.5 0 0 0-.18-.05H8.8c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22-.05.11-.05.25-.05.53v.4c0 .28 0 .42.05.53.05.09.12.17.22.22.06.03.14.05.25.05h10.67c.28 0 .42 0 .53-.05.09-.05.17-.12.22-.22.03-.06.04-.12.05-.22v-.99c0-.11-.02-.19-.05-.25zM19.95 11.27a.5.5 0 0 0-.22-.22.5.5 0 0 0-.18-.05H8.8c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22-.05.11-.05.25-.05.53v.4c0 .28 0 .42.05.53.05.09.12.17.22.22.06.03.14.05.25.05h10.67c.28 0 .42 0 .53-.05.09-.05.17-.12.22-.22.03-.06.04-.12.05-.22v-.99c0-.11-.02-.19-.05-.25zM20 6.52c0-.11-.02-.19-.05-.25a.5.5 0 0 0-.22-.22.5.5 0 0 0-.18-.05H8.8c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22C8 6.38 8 6.52 8 6.8v.4c0 .28 0 .42.05.53.05.09.12.17.22.22.06.03.14.05.25.05h10.67c.28 0 .42 0 .53-.05.09-.05.17-.12.22-.22.03-.06.04-.12.05-.22v-.99zM5 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    />
  </svg>
);
export default SvgList;
